module.exports = __webpack_public_path__ + "img/sound-table-icon.d293a859.svg";